export const UNDERWRITER_TYPE = "UNDERWRITER";
export const BROKER_TYPE = "BROKER";
export const PUNI_BROKER_TYPE = "PUNI_BROKER";
export const RETAIL_BROKER_TYPE = "RETAIL_BROKER";
export const SURPLUS_BROKER_TYPE = "SURPLUS_BROKER";
export const PRODUCER_BROKER_TYPE = "PRODUCER_BROKER";
export const WHOLESALE_BROKER_TYPE = "WHOLESALE_BROKER";
export const ASSISTANT_TYPE = "ASSISTANT";

export const EMPTY_PERSON = {
  id: null,
  name: "",
  company: "",
  email: null,
  licenseNumber: "",
};

export const EMPTY_UNDERWRITER = {
  ...EMPTY_PERSON,
  type: UNDERWRITER_TYPE,
};

export const EMPTY_BROKER = {
  ...EMPTY_PERSON,
  type: BROKER_TYPE,
};

export const EMPTY_PUNI_BROKER = {
  ...EMPTY_PERSON,
  type: PUNI_BROKER_TYPE,
};

export const EMPTY_RETAIL_BROKER = {
  ...EMPTY_PERSON,
  type: RETAIL_BROKER_TYPE,
};

export const EMPTY_SURPLUS_BROKER = {
  ...EMPTY_PERSON,
  type: SURPLUS_BROKER_TYPE,
};

export const EMPTY_PRODUCER_BROKER = {
  ...EMPTY_PERSON,
  type: PRODUCER_BROKER_TYPE,
};

export const EMPTY_WHOLESALE_BROKER = {
  ...EMPTY_PERSON,
  type: WHOLESALE_BROKER_TYPE,
};

export const EMPTY_ASSISTANT = {
  ...EMPTY_PERSON,
  type: ASSISTANT_TYPE,
};

const notBlankOrNull = (x) => x && x !== "";

const notEmptyPerson = (p) =>
  notBlankOrNull(p.id) ||
  notBlankOrNull(p.name) ||
  notBlankOrNull(p.company) ||
  notBlankOrNull(p.email);

export const extractPersonFromPeople = (type) => (people) => {
  const candidates = (people?.people ?? []).filter((p) => p.type === type);
  if (candidates.length > 0) {
    const candidate = candidates[0];
    if (notEmptyPerson(candidate)) {
      const { type, ...data } = candidate;
      return data;
    }
  }
  return null;
};

export const extractBrokerFromPeople = extractPersonFromPeople(BROKER_TYPE);
export const extractPuniBrokerFromPeople = extractPersonFromPeople(
  PUNI_BROKER_TYPE
);
export const extractRetailBrokerFromPeople = extractPersonFromPeople(
  RETAIL_BROKER_TYPE
);
export const extractSurplusBrokerFromPeople = extractPersonFromPeople(
  SURPLUS_BROKER_TYPE
);
export const extractProducerBrokerFromPeople = extractPersonFromPeople(
  PRODUCER_BROKER_TYPE
);
export const extractWholesaleBrokerFromPeople = extractPersonFromPeople(
  WHOLESALE_BROKER_TYPE
);
export const extractAssistantFromPeople = extractPersonFromPeople(
  ASSISTANT_TYPE
);

export const exrtractNthUnderwriterFromPeople = (n) => (people) => {
  const underwriters = (people?.people ?? []).filter(
    (p) => p.type === UNDERWRITER_TYPE
  );
  if (underwriters.length > n) {
    const underwriter = underwriters[n];
    if (notEmptyPerson(underwriter)) {
      const { type, ...data } = underwriter;
      return data;
    }
  }
  return null;
};

export const extractPreferredUnderwriterFromProgram = (people) =>
  exrtractNthUnderwriterFromPeople(0)(people);
export const extractSecondaryUnderwriterFromProgram = (people) =>
  exrtractNthUnderwriterFromPeople(1)(people);

// Configured people are created from the broker creation form, which captures a
// single license number, but the people service stores license numbers as a list.
// A list is passed through as-is so it is never wrapped twice.
export const toCreatePersonRequest = ({ role, licenseNumber, ...person }) => {
  const licenseNumbers = [licenseNumber].flat().filter(Boolean);
  return {
    ...person,
    roles: [role],
    ...(licenseNumbers.length > 0 && { licenseNumber: licenseNumbers }),
  };
};
